import React, { useMemo } from 'react';
import { marked } from 'marked';
import DOMPurify from 'dompurify';
import './MarkdownTextRenderer.scss';

interface MarkdownTextRendererProps {
  text: string;
  className?: string;
}

const MarkdownTextRenderer: React.FC<MarkdownTextRendererProps> = ({ text, className = '' }) => {
  const renderedHtml = useMemo(() => {
    if (!text) return { __html: '' };

    // Render markdown to HTML using the exact logic from markdown-live-preview
    // @ts-ignore - Using options that may not be in TypeScript definitions but work at runtime
    const rawHtml = marked.parse(text, {
      headerIds: false,
      mangle: false,
    });

    // Sanitize the HTML to prevent XSS (same approach as markdown-live-preview)
    const sanitized = DOMPurify.sanitize(rawHtml);

    return { __html: sanitized };
  }, [text]);

  if (!text) return null;

  return (
    <div
      className={`markdown-text-renderer markdown-body ${className}`}
      dangerouslySetInnerHTML={renderedHtml}
    />
  );
};

export default MarkdownTextRenderer;
